import React from 'react';
import classNames from 'classnames';
import ScaleMinorIntervals from './DeprecatedScaleMinorIntervals';
import ScaleMajorIntervals from './DeprecatedScaleMajorIntervals';

export default class DeprecatedScaleRow extends React.Component {
  render() {
    const { scale } = this.props;

    const scaleRowStyle = {
      width: scale.totalPixelWidth() + this.props.scrollBarSize,
    };

    const scaleRowClasses = classNames(this.props.classNames, {
      'scale-row': true,
      'no-minor-intervals': this.props.noMinorInterval,
    });

    if (!this.props.canShowMediumInterval) {
      if (this.props.dashboard) {
        scaleRowStyle['height'] = '26px';
      } else if (this.props.viewOnly) {
        scaleRowStyle['height'] = '44px';
      }
    }

    if (this.props.scrollLeft) {
      scaleRowStyle.transform = `translateX(-${this.props.scrollLeft}px)`;
    }

    if (this.props.fontSize) {
      scaleRowStyle['--scale-row-font-size'] = `${this.props.fontSize}px`;
    }

    return (
      <div className={scaleRowClasses} style={scaleRowStyle}>
        <ScaleMajorIntervals
          scale={scale}
          canShowMediumInterval={this.props.canShowMediumInterval}
        />
        {!this.props.noMinorInterval && <ScaleMinorIntervals scale={scale} />}
      </div>
    );
  }
}
